import { z } from "zod";

/** Avaliação da sessão (antes vuelidate no FeedbackDetailController). */
export const feedbackSchema = z
  .object({
    trouble: z.boolean(),
    call_completed: z.boolean(),
    description: z.string(),
    testimonial: z.string(),
  })
  .superRefine((d, ctx) => {
    if (d.trouble && !d.description) {
      ctx.addIssue({ code: "custom", path: ["description"], message: "Informe a descrição do problema técnico" });
    } else if (d.description && d.description.length < 5) {
      ctx.addIssue({ code: "custom", path: ["description"], message: "Informe uma descrição mais detalhada do problema técnico" });
    }
    // o legado exigia o depoimento mesmo com o campo escondido (problema técnico + sessão não realizada),
    // o que travava o botão. Agora só é obrigatório quando o campo aparece.
    const showsTestimonial = d.call_completed || !d.trouble;
    if (!showsTestimonial) return;
    if (!d.testimonial) {
      ctx.addIssue({ code: "custom", path: ["testimonial"], message: "Deixe um depoimento" });
    } else if (d.testimonial.length < 3) {
      ctx.addIssue({ code: "custom", path: ["testimonial"], message: "Deixe um depoimento mais detalhado" });
    }
  });
export type FeedbackValues = z.infer<typeof feedbackSchema>;

/** Corpo do POST calls-rating, igual ao legado. */
export const toCallRatingBody = (v: FeedbackValues, appointmentId: number) => ({
  ...v,
  call_completed: v.trouble ? v.call_completed : true,
  appointment_id: appointmentId,
});
